import React from "react";
import QuantitySelector from "./QuantitySelector";
import { TranslateText } from "@/utils/translation";
const t = (textKey) => <TranslateText textKey={textKey} namespace="pos" />;
const TransferItemCard = ({ item, value, onChange }) => {
  return (
    <div className="border rounded-lg p-4 flex justify-between items-center">
      <div>
        <h4 className="font-medium">{item.name}</h4>
        <p className="text-xs text-gray-500">
          {t("available")} : {item.quantity}
        </p>
      </div>

      <QuantitySelector
        value={value}
        max={item.quantity}
        onChange={(quantity) => onChange(item.id, quantity)}
      />
    </div>
  );
};

export default TransferItemCard;
